/**
 * @file Shared frontend maintenance action-lock helpers.
 */

import { appData } from "../../app/state/state.js";

/**
 * Returns whether Drugs and Leave action controls are frontend-locked.
 * The persisted key remains the legacy `drugsUiLocked` config field.
 * @returns {boolean} True when the action lock is active.
 */
export function isDrugsAndLeaveActionLocked() {
  return appData.config?.drugsUiLocked === true;
}
